import App from './App.vue';
import Vue from 'vue';
// import './registerServiceWorker';
import router from '../../router';
import store from '../../store';
import { sync } from 'vuex-router-sync';
import { configPlugin } from '../../config';
import { messagePlugin } from '@/utils/getMessage';
import intersectionObserverPlugin from '../../intersectionObserver';
import { vueGtagPlugin } from '../../gtag';

Vue.config.productionTip = false;
Vue.use(messagePlugin);
Vue.use(configPlugin);
Vue.use(intersectionObserverPlugin());
Vue.use(vueGtagPlugin);

//Sync Vue Router's current $route as part of Vuex store's state.
sync(store, router);

(async () => {
    await teamNoteOauth();
    await store.dispatch('loadMain');
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');
})();

async function teamNoteOauth() {
    const { getParameterByName } = await import('@/utils/urlUtil');
    const clientId = getParameterByName('client_id', window.location.href);
    const hash = window.location.hash;

    if (clientId && hash.indexOf('#id_token=') === 0) {
        await store.dispatch('oauth', {
            token: hash.replace('#id_token=', ''),
            clientId: clientId
        });
    }
}
